import React from 'react';
import Panel from 'components/Panel';
import { FiTrash } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

// import styled from 'styled-components/macro';

interface Props {
  remove?: any;
  children?: React.ReactNode;
  close?: any;
  isVisible: boolean;
  autoclose?: boolean;
  animation?: boolean;
}

const PanelSelection = ({ remove, children, close, ...rest }: Props) => {
  const { t } = useTranslation();

  return (
    <Panel {...rest}>
      <div className="flex justify-between">
        {remove && (
          <button
            onClick={remove}
            className="ml-2 text-red-dark py-1 px-2 border border-red-dark rounded"
          >
            <FiTrash className="h-8 w-8" />
          </button>
        )}
        {close && (
          <button
            onClick={close}
            className="mr-2 py-1 px-2 text-white bg-main rounded border"
          >
            {t('Close')}
          </button>
        )}
      </div>
      {children}
    </Panel>
  );
};

export default PanelSelection;
